import { render } from "./imagenSegunda.vue?vue&type=template&id=22185bb2&scoped=true"
import script from "./imagenSegunda.vue?vue&type=script&lang=js"
export * from "./imagenSegunda.vue?vue&type=script&lang=js"

import "./imagenSegunda.vue?vue&type=style&index=0&id=22185bb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22185bb2"]])

export default __exports__